import { render } from "./login_regestration_master.vue?vue&type=template&id=681423de&scoped=true"
import script from "./login_regestration_master.vue?vue&type=script&lang=js"
export * from "./login_regestration_master.vue?vue&type=script&lang=js"

import "./login_regestration_master.vue?vue&type=style&index=0&id=681423de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681423de"]])

export default __exports__